/**
 * The Cosmos field manual — the whole book, in reading order (2026-10-05 redesign of the Help window).
 * Content lives one file per part; navigation, search and the index are in `nav.ts`; the window is
 * `modules/AtlasHelpModule.ts`. `verify:help-book` checks every page id, link and key token.
 */
import type { HelpBook } from './types.js';
import { PART_ARRIVAL } from './ch_arrival.js';
import { PART_GROUND } from './ch_ground.js';
import { PART_MAKING } from './ch_making.js';
import { PART_SOCIETY } from './ch_society.js';
import { PART_SPACE } from './ch_space.js';
import { PART_SETTINGS } from './ch_settings.js';

export const BOOK: HelpBook = [PART_ARRIVAL, PART_GROUND, PART_MAKING, PART_SOCIETY, PART_SPACE, PART_SETTINGS];

/** The page the book opens on the first time (and the target of `Home`'s "start here"). */
export const FIRST_PAGE = 'welcome/manual';
